module.exports = __webpack_public_path__ + "static/img/suomalaistapalvelua_suomi_white.3f5aafd.png";